import { SCALE_3_POINT, SCALE_4_POINT, SCALE_5_POINT, SCALE_BINARY } from '@hap/constants'

export const scaleOptions = [
  {
    label: (
      <div className="flex items-center justify-between gap-3">
        {/*<div>{capitalize(SCALE_BINARY)}</div>*/}
        <div className="flex gap-2 text-lg">
          <span className="group-data-[selection='1']:opacity-50">👎</span>
          <span className="group-data-[selection='0']:opacity-50">👍</span>
        </div>
      </div>
    ),
    value: SCALE_BINARY,
  },
  {
    label: (
      <div className="flex items-center justify-between gap-3">
        {/*<div>{SCALE_3_POINT}</div>*/}
        <div className="flex gap-2 text-lg">
          <span className="group-data-[selection='1']:opacity-50 group-data-[selection='2']:opacity-50">
            🙁
          </span>
          <span className="group-data-[selection='0']:opacity-50 group-data-[selection='2']:opacity-50">
            😐
          </span>
          <span className="group-data-[selection='0']:opacity-50 group-data-[selection='1']:opacity-50">
            😄
          </span>
        </div>
      </div>
    ),
    value: SCALE_3_POINT,
  },
  {
    label: (
      <div className="flex items-center justify-between gap-3">
        {/*<div>{SCALE_4_POINT}</div>*/}
        <div className="flex gap-2 text-lg">
          <span className="group-data-[selection='1']:opacity-50 group-data-[selection='2']:opacity-50 group-data-[selection='3']:opacity-50">
            😠
          </span>
          <span className="group-data-[selection='0']:opacity-50 group-data-[selection='2']:opacity-50 group-data-[selection='3']:opacity-50">
            😕
          </span>
          <span className="group-data-[selection='0']:opacity-50 group-data-[selection='1']:opacity-50 group-data-[selection='3']:opacity-50">
            😄
          </span>
          <span className="group-data-[selection='0']:opacity-50 group-data-[selection='1']:opacity-50 group-data-[selection='2']:opacity-50">
            🤩
          </span>
        </div>
      </div>
    ),
    value: SCALE_4_POINT,
  },
  {
    label: (
      <div className="flex items-center justify-between gap-3">
        {/*<div>{SCALE_5_POINT}</div>*/}
        <div className="flex gap-2 text-lg">
          <span className="group-data-[selection='1']:opacity-50 group-data-[selection='2']:opacity-50 group-data-[selection='3']:opacity-50 group-data-[selection='4']:opacity-50">
            😠
          </span>
          <span className="group-data-[selection='0']:opacity-50 group-data-[selection='2']:opacity-50 group-data-[selection='3']:opacity-50 group-data-[selection='4']:opacity-50">
            😕
          </span>
          <span className="group-data-[selection='0']:opacity-50 group-data-[selection='1']:opacity-50 group-data-[selection='3']:opacity-50 group-data-[selection='4']:opacity-50">
            😐
          </span>
          <span className="group-data-[selection='0']:opacity-50 group-data-[selection='1']:opacity-50 group-data-[selection='2']:opacity-50 group-data-[selection='4']:opacity-50">
            😄
          </span>
          <span className="group-data-[selection='0']:opacity-50 group-data-[selection='1']:opacity-50 group-data-[selection='2']:opacity-50 group-data-[selection='3']:opacity-50">
            🤩
          </span>
        </div>
      </div>
    ),
    value: SCALE_5_POINT,
  },
]
